<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" :stroke="color" class="fill-current stroke-current">
      <path
        fill="#fff"
        d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
      />
      <path
        fill="#09104a"
        d="M15.722 12.069c-2.234 0-4.045 1.811-4.045 4.045s1.811 4.045 4.045 4.045c2.234 0 4.045-1.811 4.045-4.045v0c0-0.002 0-0.004 0-0.006 0-2.23-1.808-4.038-4.038-4.038-0.002 0-0.005 0-0.007 0h0zM15.722 18.742c-1.452 0-2.629-1.177-2.629-2.629s1.177-2.629 2.629-2.629c1.451 0 2.628 1.176 2.629 2.627v0c0 0 0 0 0 0 0 1.453-1.176 2.631-2.629 2.634h-0zM20.875 11.904c0 0.521-0.423 0.944-0.944 0.944s-0.944-0.423-0.944-0.944c0-0.521 0.423-0.944 0.944-0.944v0c0 0 0.001 0 0.002 0 0.52 0 0.941 0.421 0.941 0.941 0 0.001 0 0.001 0 0.002v-0zM23.554 12.864c0.001-0.028 0.001-0.060 0.001-0.093 0-1.246-0.488-2.377-1.283-3.215l0.002 0.002c-0.839-0.793-1.975-1.281-3.224-1.281-0.029 0-0.057 0-0.086 0.001l0.004-0c-1.302-0.074-5.206-0.074-6.509 0-0.028-0.001-0.061-0.001-0.094-0.001-1.244 0-2.374 0.484-3.214 1.274l0.002-0.002c-0.793 0.837-1.281 1.971-1.281 3.218 0 0.031 0 0.061 0.001 0.092l-0-0.005c-0.074 1.302-0.074 5.206 0 6.509-0.001 0.028-0.001 0.060-0.001 0.093 0 1.246 0.488 2.377 1.283 3.215l-0.002-0.002c0.84 0.793 1.977 1.281 3.227 1.281 0.028 0 0.055-0 0.083-0.001l-0.004 0c1.302 0.074 5.206 0.074 6.509 0 0.028 0.001 0.060 0.001 0.093 0.001 1.246 0 2.377-0.488 3.215-1.283l-0.002 0.002c0.793-0.839 1.281-1.975 1.281-3.224 0-0.029-0-0.057-0.001-0.086l0 0.004c0.077-1.301 0.077-5.2 0-6.502zM21.87 20.763c-0.277 0.688-0.811 1.223-1.481 1.493l-0.018 0.006c-1.054 0.227-2.266 0.358-3.508 0.358-0.402 0-0.8-0.014-1.195-0.040l0.053 0.003c-0.339 0.023-0.734 0.037-1.133 0.037-1.245 0-2.46-0.13-3.631-0.377l0.114 0.020c-0.688-0.277-1.223-0.811-1.493-1.481l-0.006-0.018c-0.227-1.054-0.358-2.266-0.358-3.508 0-0.402 0.014-0.8 0.040-1.195l-0.003 0.053c-0.023-0.339-0.037-0.734-0.037-1.133 0-1.245 0.13-2.46 0.377-3.631l-0.020 0.114c0.277-0.688 0.811-1.223 1.481-1.493l0.018-0.006c1.054-0.227 2.266-0.358 3.508-0.358 0.402 0 0.8 0.014 1.195 0.040l-0.053-0.003c0.339-0.023 0.734-0.037 1.133-0.037 1.245 0 2.46 0.13 3.631 0.377l-0.114-0.020c0.688 0.277 1.223 0.811 1.493 1.481l0.006 0.018c0.227 1.054 0.358 2.266 0.358 3.508 0 0.402-0.014 0.8-0.040 1.195l0.003-0.053c0.024 0.342 0.038 0.741 0.038 1.143 0 1.242-0.13 2.453-0.378 3.621l0.020-0.114z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
